<template>
	<div>
		<el-row>
			<el-col :span="24">
				<el-form ref="form" v-loading="loadLoading" label-position="top" :model="form" :rules="rules"
					size="small" label-width="220px" :inline="true">
					<el-row>
						<div style="max-width: 600px; margin: 0 auto">
							<el-divider>
								<h3>平台入驻</h3>
							</el-divider>
						</div>
						<h3 style="margin-top: 50px">一、基本信息</h3>
						<el-col :span="24">
							<el-form-item label="商户名称(建议用企业名称)" prop="fullName">
								<el-input style="width: 300px" placeholder="请输入商户名称" maxlength="30"
									v-model="form.fullName">
								</el-input>
							</el-form-item>
							<el-form-item label="商户简称(建议用主店铺名称)" prop="shortName">
								<el-input style="width: 300px" placeholder="请输入商户简称" v-model="form.shortName">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="商户联系人" prop="linkMan">
								<el-input style="width: 300px" placeholder="请输入商户联系人" v-model="form.linkMan">
								</el-input>
							</el-form-item>
							<el-form-item label="商户联系电话" prop="linkPhone">
								<el-input style="width: 300px" placeholder="请输入商户联系电话" v-model="form.linkPhone"
									@input="handleInput">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="联系人手机号(登录账号)" prop="contactPhoneNum">
								<el-input style="width: 300px" placeholder="请输入联系人手机号" v-model="form.contactPhoneNum">
								</el-input>
								<div v-show="form.contactPhoneNum==''" style="font-size: 12px;color: gold;">
									报单成功后，此号码将默认作为商户账号，请认真填写</div>
							</el-form-item>
							<el-form-item label="商户联系人身份证号" prop="linkManId">
								<el-input style="width: 300px" placeholder="请输入商户联系人身份证号" v-model="form.linkManId">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="店铺名称(建议用分店铺名称)" prop="shopName">
								<el-input style="width: 300px" placeholder="请输入店铺名称" v-model="form.shopName">
								</el-input>
							</el-form-item>
							<el-form-item label="店铺联系人手机号" prop="mobilePhone">
								<el-input style="width: 300px" placeholder="请输入店铺联系人手机号" maxlength="11" minlength="11"
									v-model="form.mobilePhone">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="店铺详细地址" prop="address">
								<el-input style="width: 300px" placeholder="请输入店铺详细地址" maxlength="30"
									v-model="form.address">
								</el-input>
							</el-form-item>
							<el-form-item label="所属区/县" prop="district">
								<el-select v-model="form.district" clearable placeholder="请选择区/县" style="width: 300px">
									<el-option v-for="item in options" :key="item.district" :label="item.district"
										:value="item.district">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item prop="locationString">
								<template slot="label">
									<span style="color: red;">*</span>
									<span>店铺经纬度</span>
									<div style="display: flex; flex-direction: column">
										<el-input style="width: 300px" placeholder="请输入店铺经纬度" v-model="locationString">
										</el-input>
										<el-form-item prop="latitude">
											<AMapSelect :longitude="form.lng" :latitude="form.lat"
												@change="handleLocationChange" />
										</el-form-item>
									</div>
								</template>
							</el-form-item>
							<el-form-item label="联系人邮箱" prop="email">
								<el-input style="width: 300px" placeholder="请输入联系人邮箱" maxlength="30"
									v-model="form.email">
								</el-input>
							</el-form-item>
						</el-col>
						<h3>二、结算收款信息</h3>
						<el-col :span="24">
							<el-form-item label="银行账户名称(企业名称)" prop="bankAccountName">
								<el-input style="width: 300px" placeholder="请输入银行账户名称" maxlength="30"
									v-model="form.bankAccountName">
								</el-input>
							</el-form-item>
							<el-form-item label="银行账户卡号" prop="bankAccountNum">
								<el-input style="width: 300px" placeholder="请输入银行账户卡号" maxlength="30"
									v-model="form.bankAccountNum">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<!-- <el-form-item label="银行名称" prop="bankName">
								<el-input style="width: 300px" placeholder="请输入银行名称" maxlength="30"
									v-model="form.bankName">
								</el-input>
							</el-form-item>
							<el-form-item label="银行支行名称" prop="bankBranchName">
								<el-input style="width: 300px" placeholder="请输入银行支行名称" maxlength="30"
									v-model="form.bankBranchName">
								</el-input>
							</el-form-item> -->


							<el-form-item label="银行名称" prop="bankName">
								<el-select filterable v-model="form.bankName" placeholder="请选择银行名称"
									@change="getSelectValue" style="width: 300px;">
									<el-option v-for="item in classNameSelect" :label="item.bankName"
										:value="item.bankName" :key="item.bankCode">
									</el-option>
								</el-select>
							</el-form-item>


							<el-form-item label="银行支行名称" prop="bankBranchName">
								<el-select :loading="loading" remote :remote-method="remoteMethod" filterable
									v-model="form.bankBranchName" placeholder="请选择银行支行名称" :disabled="!form.bankName"
									@change="$forceUpdate()" style="width: 300px;">
									<el-option v-for="(item,index) in bankBranchSelect" :label="item" :value="item" :key="index">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :span="24">
							<el-form-item label="银行账户预留手机号" prop="bankPhone">
								<el-input style="width: 300px" placeholder="请输入银行账户预留手机号" maxlength="11"
									v-model="form.bankPhone">
								</el-input>
							</el-form-item>
							<el-form-item label="开户许可证号(存款账户编号)" prop="accountOpenLicense">
								<el-input style="width: 300px" placeholder="请输入开户许可证号"
									v-model="form.accountOpenLicense">
								</el-input>
							</el-form-item>
						</el-col>

						<el-col :span="24">
							<el-form-item label="营业执照编号" prop="licenseId">
								<el-input style="width: 300px" placeholder="请输入营业执照编号" v-model="form.licenseId">
								</el-input>
							</el-form-item>
							<el-form-item label="营业执照注册地址" prop="postalAddress">
								<el-input style="width: 300px" placeholder="请输入营业执照注册地址" v-model="form.postalAddress">
								</el-input>
							</el-form-item>
						</el-col>

						<el-col :span="24">
							<el-form-item label="营业执照开始日期" prop="licenseStartTime">
								<el-date-picker style="width: 300px" v-model="form.licenseStartTime" type="date"
									placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="营业执照截止日期" prop="licenseEndTime">
								<template slot="label">
									<span style="color: red;">*</span>
									<span>营业执照截止日期</span>
									<el-checkbox v-model="yingye" style="margin-left: 10px"
										@change="handleLicenseEndChange">无截止日期</el-checkbox>
								</template>
								<el-date-picker style="width: 300px" :disabled="yingye" v-model="form.licenseEndTime"
									type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="法人姓名" prop="certificateName">
								<el-input style="width: 300px" placeholder="请输入法人姓名" v-model="form.certificateName">
								</el-input>
							</el-form-item>
							<el-form-item label="法人身份证号" prop="certificateCode">
								<el-input style="width: 300px" placeholder="请输入法人身份证号" v-model="form.certificateCode">
								</el-input>
							</el-form-item>
							<!-- <el-form-item label="法人身份证号" prop="certificateCode">
          <el-input
            style="width: 300px"
            placeholder=""
            maxlength="20"
            v-model="form.certificateCode"
          >
          </el-input>
        </el-form-item> -->
						</el-col>

						<el-col :span="24">
							<el-form-item label="法人身份证开始日期" prop="certificateStartDate">
								<el-date-picker style="width: 300px" v-model="form.certificateStartDate" type="date"
									:picker-options="pickerOptions" placeholder="选择日期" value-format="yyyy-MM-dd">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="法人身份证截止日期" prop="certificateEndDate">
								<template slot="label">
									<span style="color: red;">*</span>
									<span>法人身份证截止日期</span>
									<el-checkbox v-model="faren" style="margin-left: 10px"
										@change="handlecertificateEndDateChange">无截止日期</el-checkbox>
								</template>
								<el-date-picker style="width: 300px" :disabled="faren" v-model="form.certificateEndDate"
									type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
								</el-date-picker>
							</el-form-item>
						</el-col>

						<!-- <el-col :span="24">
       
        <el-form-item style="width: 300px"> </el-form-item>
      </el-col> -->
					</el-row>
					<h3>三、资质图片信息</h3>
					<el-row>
						<el-col :span="24">
							<el-form-item label="法人身份证正面" prop="identityFrontUrl">
								<SingleImageUpload v-model="form.identityFrontUrl" type="stadium_cover" />
							</el-form-item>
							<el-form-item label="法人身份证反面" prop="identityOppositeUrl">
								<SingleImageUpload v-model="form.identityOppositeUrl" type="stadium_cover" />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="营业执照" prop="licenceUrl">
								<SingleImageUpload v-model="form.licenceUrl" type="stadium_cover" />
							</el-form-item>
							<el-form-item label="银行开户许可证照片(如开户许可证在一张A4纸上，需盖公章后拍照)" prop="permitUrl">
								<SingleImageUpload v-model="form.permitUrl" type="stadium_cover" />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="经营场所收银台照片(没有收银台可拍摄办公室全景照片)" prop="cashierDeskUrl">
								<SingleImageUpload v-model="form.cashierDeskUrl" type="stadium_cover" />
							</el-form-item>
							<el-form-item label="带有公司标牌的门头照(没有标牌可将公司名称打印出来贴在办公司门口拍照)" prop="doorUrl">
								<SingleImageUpload v-model="form.doorUrl" type="stadium_cover" />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="经营场所内部照片(可拍摄办公室全景照片)" prop="shopUrl">
								<SingleImageUpload v-model="form.shopUrl" type="stadium_cover" />
							</el-form-item>
							<el-form-item style="width: 300px"> </el-form-item>
						</el-col>
					</el-row>
					<el-button style="margin-bottom:20px;width: 100px;" type="primary" @click="updata">保存</el-button>
					<el-button style="margin-bottom:20px;width: 100px;" type="info" @click="goBak">返回列表</el-button>
				</el-form>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import SingleImageUpload from "../../components/SingleImageUpload";
	import AMapSelect from "../../components/select/AMapSelect/index";
	export default {
		components: {
			SingleImageUpload,
			AMapSelect,
		},
		data() {
			return {
				locationString: "",
				loadLoading: false,
				imgHideUpload: false,
				yingye: true,
				faren: true,
				classNameSelect: null,
				bankBranchSelect: null,
				loading: false,
				isFirstLoad: true,
				bankCode: null,
				form: {
					identityFrontUrl: "",
					// 其他表单字段
				},
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				district: null, // 声明 linkManId
				options: [{
						district: "东城区",
					},
					{
						district: "西城区",
					},
					{
						district: "朝阳区",
					},
					{
						district: "丰台区",
					},
					{
						district: "石景山区",
					},
					{
						district: "海淀区",
					},
					{
						district: "门头沟区",
					},
					{
						district: "房山区",
					},
					{
						district: "通州区",
					},
					{
						district: "顺义区",
					},
					{
						district: "昌平区",
					},
					{
						district: "大兴区",
					},
					{
						district: "怀柔区",
					},
					{
						district: "平谷区",
					},
					{
						district: "密云区",
					},
					{
						district: "延庆区",
					},
				],
				rules: {
					fullName: [{
							required: true,
							message: "商户名称不能为空",
							trigger: "blur"
						},
						{
							pattern: /^.{2,30}$/,
							message: "最低2个字，最大30个字",
							trigger: "blur",
						},
					],
					shortName: [{
							required: true,
							message: "商户简称不能为空",
							trigger: "blur"
						},
						{
							pattern: /^.{2,30}$/,
							message: "最低2个字，最大30个字",
							trigger: "blur",
						},
					],
					linkMan: [{
							required: true,
							message: "商户联系人不能为空",
							trigger: "blur"
						},
						{
							pattern: /^.{2,30}$/,
							message: "最低2个字，最大30个字",
							trigger: "blur",
						},
					],
					contactPhoneNum: [{
							required: true,
							message: "联系人手机号不能为空",
							trigger: "blur",
						},
						{
							pattern: /^1[^012]\d{9}$/,
							message: "联系人手机号不正确",
							trigger: "blur",
						},
					],
					linkPhone: [{
							required: true,
							message: "商户联系电话不能为空",
							trigger: "blur",
						},
						{
							pattern: /^(\d{7}|\d{3}-\d{8}|\d{11})$/,
							message: "商户联系电话格式不正确",
							trigger: "blur",
						},
						{
							min: 7,
							max: 12,
							message: "商户联系电话长度应为7到12位",
							trigger: "blur",
						},
					],
					linkManId: [{
							required: true,
							message: "联系人身份证号不能为空",
							trigger: "blur",
						},
						{
							pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/,
							message: "身份证号必须是18位数字和字母的组合,字母必须大写",
							trigger: "blur",
						},
					],
					shopName: [{
							required: true,
							message: "店铺名称不能为空",
							trigger: "blur"
						},
						{
							pattern: /^.{2,30}$/,
							message: "最低2个字，最大30个字",
							trigger: "blur",
						},
					],
					bankPhone: [{
							required: true,
							message: "银行手机号不能为空",
							trigger: "blur",
						},
						{
							pattern: /^1[^012]\d{9}$/,
							message: "手机号格式不正确",
							trigger: "blur",
						},
					],
					address: [{
							required: true,
							message: "店铺详细地址不能为空",
							trigger: "blur",
						},
						{
							pattern: /^.{2,30}$/,
							message: "最低2个字，最大30个字",
							trigger: "blur",
						},
					],
					district: [{
						required: true,
						message: "请选择所属区/县",
						trigger: "change"
					}, ],
					email: [{
							required: true,
							message: '请输入联系人邮箱',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: ['blur', 'change']
						}
					],
					bankAccountName: [{
							required: true,
							message: "银行账户名称不能为空",
							trigger: "blur",
						},
						{
							pattern: /^.{2,30}$/,
							message: "最低2个字，最大30个字",
							trigger: "blur",
						},
					],
					bankAccountNum: [{
							required: true,
							message: "银行账户卡号不能为空",
							trigger: "blur",
						},
						{
							pattern: /^\d{9,30}$/,
							message: "请输入纯数字，最低9个字，最大30个字",
							trigger: "blur",
						},
					],
					bankName: [{
							required: true,
							message: "银行名称不能为空",
							trigger: "blur"
						},
						{
							pattern: /^[\u4e00-\u9fa5]{2,30}$/,
							message: "请输入纯汉字，最低2个字，最多30个字",
							trigger: "blur",
						},
					],
					bankBranchName: [{
						required: true,
						message: "银行支行名称不能为空",
						trigger: "blur",
					}, {
						pattern: /^[\u4e00-\u9fa5]{2,30}$/,
						message: "请输入纯汉字，最低2个字，最多30个字",
						trigger: "blur",
					}, ],
					mobilePhone: [{
							required: true,
							message: "店铺联系人手机号手机号不能为空",
							trigger: "blur",
						},
						{
							pattern: /^1[^012]\d{9}$/,
							message: "联系人手机号不正确",
							trigger: "blur",
						},
					],
					accountOpenLicense: [{
							required: true,
							message: "开户许可证号不能为空",
							trigger: "blur",
						},
						{
							pattern: /^[0-9A-Z]{10,20}$/,
							message: "最低10个字，最大20个字，只能输入数字+字母，有字母必须为大写",
							trigger: "blur",
						},
					],
					licenseId: [{
						required: true,
						message: "营业执照编号不能为空",
						trigger: "blur",
					}, {
						pattern: /^[0-9A-Z]{18}$/,
						message: "必须是18位数，只能是数字+字母，有字母必须为大写",
						trigger: "blur",
					}, ],
					postalAddress: [{
						required: true,
						message: "营业执照注册地址不能为空",
						trigger: "blur",
					}, {
						pattern: /^.{2,30}$/,
						message: "最低2个字，最大30个字",
						trigger: "blur",
					}, ],
					licenseStartTime: [{
						required: true,
						message: "营业执照开始日期不能为空",
						trigger: "blur",
					}, ],
					licenseEndTime: [{
						validator: (rule, value, callback) => {
							if (value && this.form.licenseStartTime) {
								const startDate = new Date(this.form.licenseStartTime);
								const endDate = new Date(value);
								if (endDate < startDate) {
									callback(new Error("营业执照截止日期不能小于开始日期"));
								} else {
									callback();
								}
							} else if (!value && !this.yingye) {
								callback(new Error("请选择营业执照截止日期或者选择无截止日期"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					}],
					certificateName: [{
						required: true,
						message: "法人姓名不能为空",
						trigger: "blur"
					}, {
						pattern: /^.{2,30}$/,
						message: "最低2个字，最大10个字",
						trigger: "blur",
					}, ],
					certificateCode: [{
							required: true,
							message: "法人身份证号不能为空",
							trigger: "blur",
						},
						{
							pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/,
							message: "身份证号必须是18位数字和字母的组合,字母必须大写",
							trigger: "blur",
						},
					],
					certificateStartDate: [{
						required: true,
						message: "法人身份证开始日期不能为空",
						trigger: "blur",
					}, ],
					certificateEndDate: [{
						// {
						//   required: true,
						//   message: "法人身份证截止日期不能为空",
						//   trigger: "blur",
						// },
						validator: (rule, value, callback) => {
							if (value && this.form.certificateStartDate) {
								const startDate = new Date(this.form.certificateStartDate);
								const endDate = new Date(value);
								if (endDate < startDate) {
									callback(new Error("法人身份证截止日期不能小于开始日期"));
								} else {
									callback();
								}
							} else if (!value && !this.yingye) {
								callback(new Error("请选择身份证截止日期或者选择无截止日期"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					}],
					identityFrontUrl: [{
						required: true,
						message: "请上传法人身份证正面",
						trigger: "change",
					}, ],
					identityOppositeUrl: [{
						required: true,
						message: "请上传法人身份证反面",
						trigger: "change",
					}, ],
					licenceUrl: [{
						required: true,
						message: "请上传营业执照",
						trigger: "change"
					}, ],
					permitUrl: [{
						required: true,
						message: "请上传银行开户许可证照片",
						trigger: "change",
					}, ],
					cashierDeskUrl: [{
						required: true,
						message: "请上传经营场所收银台照片",
						trigger: "change",
					}, ],
					doorUrl: [{
						required: true,
						message: "请上传带有公司标牌的门头照",
						trigger: "change",
					}, ],
					shopUrl: [{
						required: true,
						message: "请上传经营场所内部照片",
						trigger: "change",
					}, ],
					// locationString:[{
					// 	required: true,
					//     message: "请上传经纬度",
					//     trigger: "blue",
					// }],
					latitude: [{
						validator: (rule, value, callback) => {
							// 判断经纬度字段是否为空
							if (!this.locationString) {
								callback(new Error('请输入经纬度'));
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}]
				},
			};
		},
		created() {
			// if (sessionStorage.getItem("userData") == null) {
			// 	this.$router.push('/home')
			// 	return false
			// }
			this.getDetail().then(() => {
				this.getbankSelect().then(() => {
					this.getSelectValue(this.form.bankName, this.bankCode)
				})
			})
		},
		methods: {
			remoteMethod(query) {
				this.getSelectValue(query)
			},
			getSelectValue(subBankName) {
				const selectedBank = this.classNameSelect.find(item => item.bankName === subBankName);
				let bankCode = null;
				if (selectedBank) {
					bankCode = selectedBank.bankCode;
					this.bankCode = bankCode
				} else {
					bankCode = this.bankCode
				}
				this.getClassNmae(subBankName, bankCode)
			},
			getClassNmae(subBankName, bankCode) {
				if (!this.isFirstLoad) {
					this.bankBranchSelect = []
					this.form.bankBranchName = null
				}
				this.$axios.get(`/open/v1/customers/sub_bank_list?bankCode=${bankCode}&subBankName=${subBankName}`)
					.then((res) => {
						this.bankBranchSelect = res.data.data
						this.isFirstLoad = false

						this.bankCode = bankCode
					})
					.catch((error) => {

					});
			},
			getbankSelect() {
				return new Promise((resolve, reject) => {
					this.$axios.get(`/open/v1/customers/bank_list?bankName=`)
						.then((res) => {
							this.classNameSelect = res.data.data.bankList
							resolve()
						})
						.catch((error) => {
							reject()
						});
				})
			},
			goBak() {
				this.$router.go(-1);
			},
			handlecertificateEndDateChange(val) {
				// 清除截止日期的验证规则
				if (val) {
					this.$refs.form.clearValidate('certificateEndDate');
					this.form.certificateEndDate = ''; // 清空截止日期的值
				}
			},
			handleLicenseEndChange(val) {
				// 清除截止日期的验证规则
				if (val) {
					this.$refs.form.clearValidate('licenseEndTime');
					this.form.licenseEndTime = ''; // 清空截止日期的值
				}
			},
			handleInput() {
				// 移除非数字和横杠的字符
				this.form.linkPhone = this.form.linkPhone.replace(/[^\d-]/g, '');
			},
			getDetail() {
				return new Promise((resolve, reject) => {
					this.$axios.get(`/open/v1/customers/${this.$route.query.id}/info`).then((res) => {
						if (res.data.code == 200) {
							this.form = res.data.data;
							resolve()
							this.locationString = this.form.lng + "," + this.form.lat;
						} else {
							reject()
							this.locationString = this.form.lng + "," + this.form.lat;
						}
					});
				})
			},
			handleLocationChange(location) {
				this.locationString = location.join(",");
				this.form = {
					...this.form,
					lng: location[0],
					lat: location[1],
				};
			},
			updata() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.loadLoading = true
						let id=this.form.id
						this.$axios({
							url: `/open/v1/customers/${id}`,
							data: this.form,
							method: "POST",
							headers: {
								"Content-Type": "application/json", // 设置请求的内容类型为 JSON
							},
						}).then((res) => {
							if (res.data.code == 200) {
								this.$message({
									message: res.data.message,
									type: "success",
								});
								this.$router.go(-1);
								// 假设你想返回上一个页面，并携带参数
								// const params = {
								// 	status: "success",
								// 	id:id
								// };
								// 使用 $router.push() 方法，指定要返回的页面，并传递参数
								// this.$router.push({
								// 	path: '/taxationFormList', // 上一个页面的路由路径
								// 	query: params, // 参数对象
								// });

							} else {
								this.$message({
									message: res.data.message,
									type: "error",
								});
							}
						}).finally(() => {
							this.loadLoading = false
						})
					}
				});
			},
		},
	};
</script>

<style scoped>
	/* 这里放置你的样式 */
	.el-col-24 {
		text-align: center;
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
	}

	::v-deep.el-form--inline .el-form-item__label {
		width: 100%;
		max-width: 300px;
	}

	.imgHide .el-upload--picture-card {
		display: none;
	}

	@media (max-width: 600px) {
		::v-deep.el-input--small .el-input__inner {
			width: 100% !important;
		}
	}
</style>